export const BracketRight = (props: any) => (
  <svg
    {...props}
    width="10"
    height="38"
    viewBox="0 0 10 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.65183 37.4995H9.15183V36.9995V35.9236V35.4236H8.65183H7.00149C4.56168 35.4236 2.57641 33.4379 2.57641 30.9985V7.00149C2.57641 4.56168 4.56211 2.57641 7.00149 2.57641H8.65183H9.15183V2.07641V1V0.5H8.65183H7.00149C3.41587 0.5 0.5 3.41587 0.5 7.00149V30.998C0.5 34.5837 3.41638 37.4995 7.00149 37.4995H8.65183Z"
      fill="currentColor"
      stroke="currentColor"
    />
  </svg>
)
